import React, { useState, useEffect } from 'react';
import { getOrders, createOrder, updateOrder, deleteOrder, getCustomers, createPayment, deletePayment, updateCustomer, bulkDeleteOrders, getRepresentatives, createRepresentative, deleteRepresentative } from '../services/api';
import Modal from '../components/Modal';
import ConfirmModal from '../components/Confirmmodal';
import Navbar from '../components/Navbar';
import OrderCalendar from '../components/OrderCalendar';
import { exportOrdersToExcel } from '../utils/exportUtils';
import { printDeliveryNote } from '../utils/invoiceUtils';
import toast from 'react-hot-toast';
import '../styles/Pages.css';
import '../styles/Calendar.css';
import { useAuth } from '../context/AuthContext';
import ImportExport from '../components/ImportExport';
import { formatCurrency, formatDate } from '../utils/formatters';
import { useLocation } from 'react-router-dom';





// Telefon numarasını formatla (görüntüleme için)
const formatPhoneNumber = (value) => {
  if (!value) return '';
  let numbers = value.replace(/\D/g, '');
  if (numbers.startsWith('0')) {
    numbers = numbers.slice(1);
  }
  const limited = numbers.slice(0, 10);
  if (limited.length === 0) return '';
  if (limited.length <= 3) return `0(${limited}`;
  if (limited.length <= 6) return `0(${limited.slice(0, 3)}) ${limited.slice(3)}`;
  if (limited.length <= 8) return `0(${limited.slice(0, 3)}) ${limited.slice(3, 6)} ${limited.slice(6)}`;
  return `0(${limited.slice(0, 3)}) ${limited.slice(3, 6)} ${limited.slice(6, 8)} ${limited.slice(8)}`;
};

// Telefon numarasını normalize et (arama için) - tüm format karakterlerini kaldır
const normalizePhone = (phone) => {
  if (!phone) return '';
  return phone.replace(/\D/g, ''); // Sadece rakamları al
};

// localStorage anahtarı
const FILTER_STORAGE_KEY = 'orders_filters';

// Filtreleri localStorage'dan yükle
const loadFiltersFromStorage = () => {
  try {
    const saved = localStorage.getItem(FILTER_STORAGE_KEY);
    if (saved) return JSON.parse(saved);
  } catch (e) {
    console.log('Filtre yükleme hatası:', e);
  }
  return null;
};

// Filtreleri localStorage'a kaydet
const saveFiltersToStorage = (filters) => {
  try {
    localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(filters));
  } catch (e) {
    console.log('Filtre kaydetme hatası:', e);
  }
};

function Orders() {
  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [editingOrder, setEditingOrder] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  
  // Filtreler - localStorage'dan yükle
  const savedFilters = loadFiltersFromStorage();
  const [searchTerm, setSearchTerm] = useState(savedFilters?.searchTerm || '');
  const [statusFilter, setStatusFilter] = useState(savedFilters?.statusFilter || '');
  const [paymentStatusFilter, setPaymentStatusFilter] = useState(savedFilters?.paymentStatusFilter || '');
  const [dateFrom, setDateFrom] = useState(savedFilters?.dateFrom || '');
  const [dateTo, setDateTo] = useState(savedFilters?.dateTo || '');
  const [selectedYear, setSelectedYear] = useState(savedFilters?.selectedYear || '');
  const [selectedMonth, setSelectedMonth] = useState(savedFilters?.selectedMonth || '');
  
  const { hasPermission } = useAuth();
  const location = useLocation();


  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [grandTotals, setGrandTotals] = useState({ total_revenue: 0, total_paid: 0, total_remaining: 0 });
  const [pageSize, setPageSize] = useState(() => {
  const saved = localStorage.getItem('userPageSize');
  return saved ? Number(saved) : 50;
  });

  const [viewMode, setViewMode] = useState(savedFilters?.viewMode || 'list'); 
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectMode, setSelectMode] = useState(false);
  const [representatives, setRepresentatives] = useState([]);
  const [representativeFilter, setRepresentativeFilter] = useState(savedFilters?.representativeFilter || '');
  const [newRepresentative, setNewRepresentative] = useState('');
  const [showRepInput, setShowRepInput] = useState(false);

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'danger',
    onConfirm: () => {},
    confirmText: 'Evet',
    loading: false
  });

  const [formData, setFormData] = useState({
    customer_id: '',
    customer_name: '',
    customer_phone: '',
    job_type: '',
    description: '',
    status: 'siparis_alindi',
    order_date: new Date().toISOString().split('T')[0],
    delivery_date: '',
    total_price: '',
    base_price: '', 
    kdv_rate: 20, 
    down_payment: '',
    down_payment_method: 'nakit', 
    invoice_included: false,
    invoice_no: '',
    representative: ''
  });

  const [paymentData, setPaymentData] = useState({
    amount: 0,
    payment_date: new Date().toISOString().split('T')[0],
    payment_method: 'nakit',
    notes: ''
  });

  const [refundData, setRefundData] = useState({
    amount: 0,
    payment_date: new Date().toISOString().split('T')[0],
    payment_method: 'nakit',
    notes: ''
  });

  const [customerSearchTerm, setCustomerSearchTerm] = useState('');
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [filteredCustomers, setFilteredCustomers] = useState([]);

  // Yıl ve ay seçenekleri
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => (currentYear - 1) + i);
  const months = [
    { value: 1, label: 'Ocak' }, { value: 2, label: 'Şubat' },
    { value: 3, label: 'Mart' }, { value: 4, label: 'Nisan' },
    { value: 5, label: 'Mayıs' }, { value: 6, label: 'Haziran' },
    { value: 7, label: 'Temmuz' }, { value: 8, label: 'Ağustos' },
    { value: 9, label: 'Eylül' }, { value: 10, label: 'Ekim' },
    { value: 11, label: 'Kasım' }, { value: 12, label: 'Aralık' }
  ];

  useEffect(() => {
  setLoading(true);
  Promise.all([fetchData(1), fetchStaticData()]).finally(() => setLoading(false));
}, []);

useEffect(() => {
  const timer = setTimeout(() => {
    fetchData(1);
  }, 600);
  return () => clearTimeout(timer);
}, [searchTerm, statusFilter, paymentStatusFilter, dateFrom, dateTo, representativeFilter]);


  // Filtreleri localStorage'a kaydet
  useEffect(() => {
    saveFiltersToStorage({
      searchTerm,
      statusFilter,
      paymentStatusFilter,
      dateFrom,
      dateTo,
      selectedYear,
      selectedMonth,
      viewMode,
      representativeFilter
    });
  }, [searchTerm, statusFilter, paymentStatusFilter, dateFrom, dateTo, selectedYear, selectedMonth, viewMode, representativeFilter]);

  // Yıl/Ay seçildiğinde tarih aralığını otomatik ayarla
  useEffect(() => {
    if (selectedYear && selectedMonth) {
      const year = parseInt(selectedYear);
      const month = parseInt(selectedMonth);
      // Ayın ilk günü - düzgün format
      const firstDay = `${year}-${String(month).padStart(2, '0')}-01`;
      // Ayın son günü - Date(year, month, 0) bir sonraki ayın 0. günü = bu ayın son günü
      const lastDayDate = new Date(year, month, 0);
      const lastDay = `${year}-${String(month).padStart(2, '0')}-${String(lastDayDate.getDate()).padStart(2, '0')}`;
      setDateFrom(firstDay);
      setDateTo(lastDay);
    } else if (selectedYear && !selectedMonth) {
      const year = parseInt(selectedYear);
      setDateFrom(`${year}-01-01`);
      setDateTo(`${year}-12-31`);
    }
  }, [selectedYear, selectedMonth]);

  useEffect(() => {
  if (location.state?.openOrderId && orders.length > 0) {
    const order = orders.find(o => o.id === location.state.openOrderId);
    if (order) {
      handleOpenDetailModal(order);
      // State'i temizle ki tekrar açılmasın
      window.history.replaceState({}, document.title);
    }
  }
}, [orders, location.state]);

 const fetchData = async (page = 1, size = pageSize) => {
  try {
    const params = { page, limit: size };
    if (searchTerm) params.search = searchTerm;
    if (statusFilter) params.status = statusFilter;
    if (paymentStatusFilter) params.payment_status = paymentStatusFilter;
    if (dateFrom) params.date_from = dateFrom;
    if (dateTo) params.date_to = dateTo;
    if (representativeFilter) params.representative = representativeFilter;

    const ordersRes = await getOrders(params);
    setOrders(ordersRes.data.items);
    setTotalPages(ordersRes.data.pages);
    setTotalCount(ordersRes.data.total);
    setCurrentPage(page);
    setGrandTotals(ordersRes.data.totals || { total_revenue: 0, total_paid: 0, total_remaining: 0 });
  } catch (error) {
    console.error('Error:', error);
    toast.error('Veri yüklenirken hata oluştu');
  }
};

const fetchStaticData = async () => {
  try {
    const [customersRes, repsRes] = await Promise.all([
      getCustomers({ page: 1, limit: 500 }),
      getRepresentatives()
    ]);
    setCustomers(customersRes.data.items || customersRes.data);
    setRepresentatives(repsRes.data);
  } catch (error) {
    console.error('Error:', error);
  }
};

  const handleOpenModal = (order = null) => {
    if (order) {
      setEditingOrder(order);
      setFormData({
        customer_id: order.customer_id || '',
        customer_name: order.customer_name || '',
        customer_phone: order.customer_phone || '',
        job_type: order.job_type || '',
        description: order.description || '',
        status: order.status || 'siparis_alindi',
        order_date: order.order_date || new Date().toISOString().split('T')[0],
        delivery_date: order.delivery_date || '',
        total_price: order.total_price || '',
        base_price: order.base_price || order.total_price || '',
        kdv_rate: order.kdv_rate || 20,
        down_payment: order.down_payment || '',
        down_payment_method: order.down_payment_method || 'nakit',
        invoice_included: order.invoice_included || false,
        invoice_no: order.invoice_no || '',
        representative: order.representative || ''
      });
      setCustomerSearchTerm(order.customer_name || '');
    } else {
      setEditingOrder(null);
      setFormData({
        customer_id: '',
        customer_name: '',
        customer_phone: '',
        job_type: '',
        description: '',
        status: 'siparis_alindi',
        order_date: new Date().toISOString().split('T')[0],
        delivery_date: '',
        total_price: '',
        base_price: '',
        kdv_rate: 20,
        down_payment: '',
        down_payment_method: 'nakit',
        invoice_included: false,
        invoice_no: '',
        representative: ''
      });
      setCustomerSearchTerm('');
    }
    setShowCustomerDropdown(false);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
  setIsModalOpen(false);
  setEditingOrder(null);
  setCustomerSearchTerm('');
  setShowCustomerDropdown(false);
  setShowRepInput(false);
  setNewRepresentative('');
};

  const handleCustomerSearch = (searchValue) => {
    setCustomerSearchTerm(searchValue);
    if (searchValue.trim().length > 0) {
      const normalizedSearch = normalizePhone(searchValue);
      const filtered = customers.filter(c => {
        // İsim araması
        const nameMatch = c.name?.toLowerCase().includes(searchValue.toLowerCase());
        // Telefon araması - normalize edilmiş
        const phoneMatch = normalizedSearch.length > 0 && normalizePhone(c.phone).includes(normalizedSearch);
        return nameMatch || phoneMatch;
      }).slice(0, 10);
      setFilteredCustomers(filtered);
      setShowCustomerDropdown(true);
    } else {
      setFilteredCustomers([]);
      setShowCustomerDropdown(false);
    }
  };

  const handleSelectCustomer = (customer) => {
    setFormData({
      ...formData,
      customer_id: customer.id,
      customer_name: customer.name,
      customer_phone: customer.phone || ''
    });
    setCustomerSearchTerm(customer.name);
    setShowCustomerDropdown(false);
  };

  const handleManualEntry = () => {
    setFormData({
      ...formData,
      customer_id: '',
      customer_name: customerSearchTerm,
      customer_phone: ''
    });
    setShowCustomerDropdown(false);
  };

  const handleClearCustomer = () => {
    setFormData({
      ...formData,
      customer_id: '',
      customer_name: '',
      customer_phone: ''
    });
    setCustomerSearchTerm('');
    setShowCustomerDropdown(false);
  };

  // Tüm filtreleri temizle
  const clearAllFilters = () => {
  setSearchTerm('');
  setStatusFilter('');
  setPaymentStatusFilter('');
  setDateFrom('');
  setDateTo('');
  setSelectedYear('');
  setSelectedMonth('');
  setRepresentativeFilter('');
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const loadingToast = toast.loading(editingOrder ? 'Güncelleniyor...' : 'Oluşturuluyor...');
    
    const submitData = {
      ...formData,
      total_price: parseFloat(formData.total_price) || 0,
      base_price: parseFloat(formData.base_price) || parseFloat(formData.total_price) || 0,
      kdv_rate: formData.invoice_included ? formData.kdv_rate : null,
      down_payment: parseFloat(formData.down_payment) || 0,
      down_payment_method: formData.down_payment && parseFloat(formData.down_payment) > 0 
      ? formData.down_payment_method 
      : null,
      customer_id: formData.customer_id ? parseInt(formData.customer_id) : null,
      order_date: formData.order_date || null,
      delivery_date: formData.delivery_date || null,
    };
    
    try {
      if (editingOrder) {
        await updateOrder(editingOrder.id, submitData);
        
        if (formData.customer_id) {
          const originalCustomer = customers.find(c => c.id === parseInt(formData.customer_id));
          if (originalCustomer) {
            const needsUpdate = 
              originalCustomer.phone !== formData.customer_phone ||
              originalCustomer.name !== formData.customer_name;
            
            if (needsUpdate) {
              try {
                await updateCustomer(formData.customer_id, {
                  ...originalCustomer,
                  name: formData.customer_name,
                  phone: formData.customer_phone
                });
                toast.success('Müşteri bilgileri de güncellendi', { duration: 2000 });
              } catch (e) {
                console.log('Müşteri güncelleme uyarısı:', e);
              }
            }
          }
        }
        
        toast.success('Sipariş güncellendi!', { id: loadingToast });
      } else {
        await createOrder(submitData);
        
        if (formData.customer_id) {
          const originalCustomer = customers.find(c => c.id === parseInt(formData.customer_id));
          if (originalCustomer) {
            const needsUpdate = 
              originalCustomer.phone !== formData.customer_phone ||
              originalCustomer.name !== formData.customer_name;
            
            if (needsUpdate) {
              try {
                await updateCustomer(formData.customer_id, {
                  ...originalCustomer,
                  name: formData.customer_name,
                  phone: formData.customer_phone
                });
              } catch (e) {
                console.log('Müşteri güncelleme uyarısı:', e);
              }
            }
          }
        }
        
        toast.success('Sipariş oluşturuldu!', { id: loadingToast });
      }
      handleCloseModal();
      fetchData();
    } catch (error) {
      console.error('Tam hata:', error);
      let errorMessage = 'İşlem başarısız';
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          errorMessage = error.response.data.detail.map(err => `${err.loc?.join('.')}: ${err.msg}`).join(' | ');
        } else if (typeof error.response.data.detail === 'string') {
          errorMessage = error.response.data.detail;
        }
      }
      toast.error(errorMessage, { id: loadingToast, duration: 5000 });
    }
  };

  const handleDeleteClick = (order) => {
    setConfirmModal({
      isOpen: true,
      title: 'Sipariş Silme',
      message: `#${order.id} numaralı "${order.customer_name}" siparişini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz!`,
      type: 'danger',
      confirmText: 'Evet, Sil',
      loading: false,
      onConfirm: () => handleDeleteConfirm(order.id)
    });
  };

const handleBulkDelete = () => {
    setConfirmModal({
      isOpen: true,
      title: 'Toplu Sipariş Silme',
      message: `${selectedIds.length} siparişi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz!`,
      type: 'danger',
      confirmText: `Evet, ${selectedIds.length} Siparişi Sil`,
      loading: false,
      onConfirm: handleBulkDeleteConfirm
    });
  };

  const handleBulkDeleteConfirm = async () => {
    setConfirmModal(prev => ({ ...prev, loading: true }));
    try {
      await bulkDeleteOrders(selectedIds);
      toast.success(`${selectedIds.length} sipariş silindi`);
      setSelectedIds([]);
      setConfirmModal(prev => ({ ...prev, isOpen: false }));
      fetchData(currentPage);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Silme hatası');
      setConfirmModal(prev => ({ ...prev, loading: false }));
    }
  };


  const handleDeleteConfirm = async (id) => {
    setConfirmModal(prev => ({ ...prev, loading: true }));
    try {
      await deleteOrder(id);
      toast.success('Sipariş silindi');
      setConfirmModal(prev => ({ ...prev, isOpen: false }));
      fetchData();
    } catch (error) {
      console.error('Error:', error);
      toast.error('Silme hatası');
      setConfirmModal(prev => ({ ...prev, loading: false }));
    }
  };

  const getPaymentStatus = (order) => {
    const totalPaid = order.total_paid || 0;
    const totalPrice = order.total_price || 0;
    if (totalPrice <= 0) return 'none';
    if (totalPaid >= totalPrice) return 'paid';
    if (totalPaid > 0) return 'partial';
    return 'unpaid';
  };

  const getPaymentStatusLabel = (status) => {
    const labels = {
      'paid': 'Tam Ödendi',
      'partial': 'Kısmi Ödeme',
      'unpaid': 'Ödenmedi',
      'none': '-'
    };
    return labels[status] || '-';
  };

  const getPaymentStatusClass = (status) => {
    const classes = {
      'paid': 'badge-success',
      'partial': 'badge-warning',
      'unpaid': 'badge-danger',
      'none': 'badge-secondary'
    };
    return classes[status] || 'badge-secondary';
  };


  const handleExport = async () => {
  const loadingToast = toast.loading('Veriler hazırlanıyor...');
  try {
    const params = { page: 1, limit: 1000 };
    if (searchTerm) params.search = searchTerm;
    if (statusFilter) params.status = statusFilter;
    if (paymentStatusFilter) params.payment_status = paymentStatusFilter;
    if (dateFrom) params.date_from = dateFrom;
    if (dateTo) params.date_to = dateTo;
    if (representativeFilter) params.representative = representativeFilter;
    const res = await getOrders(params);
    exportOrdersToExcel(res.data.items);
    toast.success(`${res.data.items.length} sipariş indirildi!`, { id: loadingToast });
  } catch (error) {
    toast.error('İndirme hatası', { id: loadingToast });
  }
};

  const handleOpenDetailModal = (order) => {
    setSelectedOrder(order);
    setIsDetailModalOpen(true);
  };

  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false);
    setSelectedOrder(null);
  };

  const handleOpenPaymentModal = () => {
    setPaymentData({
      amount: 0,
      payment_date: new Date().toISOString().split('T')[0],
      payment_method: 'nakit',
      notes: ''
    });
    setIsPaymentModalOpen(true);
  };

  const handleClosePaymentModal = () => {
    setIsPaymentModalOpen(false);
  };

  const handleOpenRefundModal = () => {
    setRefundData({
      amount: 0,
      payment_date: new Date().toISOString().split('T')[0],
      payment_method: 'nakit',
      notes: ''
    });
    setIsRefundModalOpen(true);
  };

  const handleCloseRefundModal = () => {
    setIsRefundModalOpen(false);
  };

  const handleAddPayment = async (e) => {
    e.preventDefault();
    const loadingToast = toast.loading('Ödeme kaydediliyor...');
    try {
      await createPayment({
        order_id: selectedOrder.id,
        ...paymentData
      });
      toast.success('Ödeme eklendi!', { id: loadingToast });
      handleClosePaymentModal();
      const updatedOrder = await getOrders({ page: currentPage, limit: pageSize });
      const refreshedOrder = updatedOrder.data.items.find(o => o.id === selectedOrder.id);
      setSelectedOrder(refreshedOrder);
      fetchData();
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.detail || 'Ödeme eklenemedi', { id: loadingToast });
    }
  };

  const handleAddRefund = async (e) => {
    e.preventDefault();
    const loadingToast = toast.loading('İade kaydediliyor...');
    try {
      await createPayment({
        order_id: selectedOrder.id,
        amount: -Math.abs(refundData.amount),
        payment_date: refundData.payment_date,
        payment_method: refundData.payment_method,
        notes: `[İADE] ${refundData.notes || 'Ödeme iadesi'}`
      });
      toast.success('İade kaydedildi!', { id: loadingToast });
      handleCloseRefundModal();
      const updatedOrder = await getOrders({ page: currentPage, limit: pageSize });
      const refreshedOrder = updatedOrder.data.items.find(o => o.id === selectedOrder.id);
      setSelectedOrder(refreshedOrder);
      fetchData();
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.detail || 'İade eklenemedi', { id: loadingToast });
    }
  };

  const handleDeletePaymentClick = (payment) => {
    setConfirmModal({
      isOpen: true,
      title: 'Ödeme Silme',
      message: `${formatCurrency(payment.amount)}
 tutarındaki ödeme kaydını silmek istediğinizden emin misiniz?`,
      type: 'danger',
      confirmText: 'Evet, Sil',
      loading: false,
      onConfirm: () => handleDeletePaymentConfirm(payment.id)
    });
  };

  const handleDeletePaymentConfirm = async (paymentId) => {
    setConfirmModal(prev => ({ ...prev, loading: true }));
    try {
      await deletePayment(paymentId);
      toast.success('Ödeme silindi');
      setConfirmModal(prev => ({ ...prev, isOpen: false }));
      const updatedOrder = await getOrders({ page: currentPage, limit: pageSize });
      const refreshedOrder = updatedOrder.data.items.find(o => o.id === selectedOrder.id);
      setSelectedOrder(refreshedOrder);
      fetchData();
    } catch (error) {
      console.error('Error:', error);
      toast.error('Silme hatası');
      setConfirmModal(prev => ({ ...prev, loading: false }));
    }
  };


  const getStatusLabel = (status) => {
    const statusLabels = {
      'siparis_alindi': 'Sipariş Alındı',
      'uretimde': 'Üretimde',
      'teslim_edildi': 'Teslim Edildi'
    };
    return statusLabels[status] || status;
  };

  const handlePrintDeliveryNote = () => {
    if (selectedOrder) {
      printDeliveryNote(selectedOrder);
    }
  };

  // Aktif filtre var mı kontrolü
  const hasActiveFilters = searchTerm || statusFilter || paymentStatusFilter || dateFrom || dateTo || selectedYear || representativeFilter;

  if (loading) {
    return <div className="loading">Yükleniyor...</div>;
  }

  return (
    <div className="page-container">
      <Navbar />

      <div className="page-content">
        <div className="page-header">
          <h2>Siparişler ({totalCount})</h2>
          <div className="header-actions">
            
            {/* TAKVİM/LİSTE TOGGLE */}
            <button 
              className={`btn-toggle-view ${viewMode === 'calendar' ? 'active' : ''}`}
              onClick={() => setViewMode(viewMode === 'list' ? 'calendar' : 'list')}
              style={{
              padding: '10px 16px',
              background: viewMode === 'calendar' 
                ? 'linear-gradient(135deg, #667eea, #764ba2)' 
                : 'white',
              color: viewMode === 'calendar' ? 'white' : '#667eea',
              border: '1px solid #667eea',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: '13px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
            >
              {viewMode === 'calendar' ? '📋 Liste' : '📅 Takvim'}
            </button>
            <ImportExport onImportSuccess={fetchData} dateFrom={dateFrom} dateTo={dateTo} />
            <button className="btn-export" onClick={handleExport}>
              📥 Excel'e Aktar
            </button>
            {selectMode ? (
              <>
                {selectedIds.length > 0 && hasPermission('delete_orders') && (
                  <button
                    onClick={handleBulkDelete}
                    style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'linear-gradient(135deg,#ff5252,#d32f2f)', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                  >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <polyline points="3 6 5 6 21 6"/>
                      <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                      <path d="M10 11v6M14 11v6"/>
                      <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                    </svg>
                    Seçilenleri Sil ({selectedIds.length}) 
                  </button>
                )}
                <button
                  onClick={() => { setSelectMode(false); setSelectedIds([]); }}
                  style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'#f0f0f0', color:'#333', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path d="M18 6L6 18M6 6l12 12"/>
                  </svg>
                  İptal
                </button>
              </>
            ) : (
              hasPermission('delete_orders') && (
                <button
                  onClick={() => setSelectMode(true)}
                  style={{
                    display:'flex', alignItems:'center', gap:'6px',
                    padding:'10px 20px',
                    background:'linear-gradient(135deg, #667eea, #764ba2)',
                    color:'white',
                    border:'none',
                    borderRadius:'8px',
                    cursor:'pointer',
                    fontWeight:'550'
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <rect x="3" y="3" width="18" height="18" rx="3"/>
                    <path d="M7 12l4 4 6-7"/>
                  </svg>
                  Seç
                </button>
              )
            )}
            {hasPermission('create_orders') && (
            <button className="btn-primary" onClick={() => handleOpenModal()}>
              + Yeni Sipariş
             </button>
             )}
          </div>
        </div>

        <div className="filters">
          <input
            type="text"
            placeholder="Müşteri, telefon veya iş tipi ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="filter-select"
          >
            <option value="">Tüm Durumlar</option>
            <option value="siparis_alindi">Sipariş Alındı</option>
            <option value="uretimde">Üretimde</option>
            <option value="teslim_edildi">Teslim Edildi</option>
          </select>
          <select
            value={paymentStatusFilter}
            onChange={(e) => setPaymentStatusFilter(e.target.value)}
            className="filter-select"
          >
            <option value="">Tüm Ödemeler</option>
            <option value="paid">Tam Ödendi</option>
            <option value="partial">Kısmi Ödeme</option>
            <option value="unpaid">Ödenmedi</option>
          </select>
          <select
            value={representativeFilter}
            onChange={(e) => setRepresentativeFilter(e.target.value)}
            className="filter-select"
          >
            <option value="">Tüm Siparişi Alanlar</option>
            {representatives.map(rep => (
              <option key={rep.id} value={rep.name}>{rep.name}</option>
            ))}
          </select>

          {/* Yıl/Ay Hızlı Seçim */}
          <select
            value={selectedYear}
            onChange={(e) => {
              setSelectedYear(e.target.value);
              if (!e.target.value) {
                setSelectedMonth('');
                setDateFrom('');
                setDateTo('');
              }
            }}
            className="filter-select"
            style={{minWidth: '90px'}}
          >
            <option value="">Yıl</option>
            {years.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
            className="filter-select"
            disabled={!selectedYear}
            style={{minWidth: '100px'}}
          >
            <option value="">Tüm Aylar</option>
            {months.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
          </select>
          <span className="date-filter-divider">veya</span>
          
          <input
            type="date"
            value={dateFrom}
            onChange={(e) => {
              setDateFrom(e.target.value);
              setSelectedYear('');
              setSelectedMonth('');
            }}
            className="filter-date"
            style={{minWidth:'115px', maxWidth:'115px'}}
          />
          <input
            type="date"
            value={dateTo}
            onChange={(e) => {
              setDateTo(e.target.value);
              setSelectedYear('');
              setSelectedMonth('');
            }}
            className="filter-date"
            style={{minWidth:'115px', maxWidth:'115px'}}
          />

          {hasActiveFilters && (
            <button 
              className="btn-clear-filter"
              onClick={clearAllFilters}
              title="Tüm Filtreleri Temizle"
            >
              ✕
            </button>
          )}
        </div>

        {/* TAKVİM VEYA LİSTE GÖRÜNÜMÜ */}
        {viewMode === 'calendar' ? (
          <OrderCalendar 
            orders={orders} 
            onOrderClick={handleOpenDetailModal} 
          />
        ) : (
          <div className="table-container">
            <table>
              <thead>
              <tr>
                {selectMode && (
                  <th style={{width: '40px'}}>
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedIds(orders.map(o => o.id));
                        } else {
                          setSelectedIds([]);
                        }
                      }}
                      checked={selectedIds.length === orders.length && orders.length > 0}
                    />
                  </th>
                )}
              <th>Tarih</th>
              <th>Müşteri</th>
              <th>Siparişi Alan</th>
              <th>İş Tipi</th>
              <th>Durum</th>
              <th>Ödeme Durumu</th>
              <th>Toplam</th>
              <th>Ödenen</th>
              <th>Kalan</th>
              <th>Fatura</th>
              <th>F. No</th>
              <th>İşlemler</th>
              </tr>
            </thead>
              <tbody>
                {orders.map(order => {
                  const paymentStatus = getPaymentStatus(order);
                  return (
                    <tr key={order.id}>
                      {selectMode && (
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedIds.includes(order.id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedIds(prev => [...prev, order.id]);
                              } else {
                                setSelectedIds(prev => prev.filter(id => id !== order.id));
                              }
                            }}
                          />
                        </td>
                      )}
                      <td title={`#${order.id}`}>{formatDate(order.order_date)}</td>                      
                      <td>{order.customer_name || '-'}</td>
                      <td>{order.representative || '-'}</td>
                      <td>{order.job_type || '-'}</td>
                      <td>
                        <span className={`status-badge status-${order.status}`}>
                          {getStatusLabel(order.status)}
                        </span>
                      </td>
                      <td>
                        <span className={`badge ${getPaymentStatusClass(paymentStatus)}`}>
                          {getPaymentStatusLabel(paymentStatus)}
                        </span>
                      </td>
                      <td>{formatCurrency(order.total_price)}</td>
                      <td>{formatCurrency(order.total_paid)}</td>
                      <td>{formatCurrency(order.remaining_balance)}</td>
                      <td>
                        <span className={`badge ${order.invoice_included ? 'badge-success' : 'badge-secondary'}`}>
                          {order.invoice_included ? 'Evet' : 'Hayır'}
                        </span>
                      </td>
                      <td>{order.invoice_no || '-'}</td>   
                      <td>
                        <div className="action-buttons">
                          <button 
                            className="btn-view"
                            onClick={() => handleOpenDetailModal(order)}
                            title="Detay"
                          >
                            👁
                          </button>
                          {hasPermission('edit_orders') && (
                           <button className="btn-edit" onClick={() => handleOpenModal(order)} title="Düzenle">
                                ✎
                           </button>
                           )}
                          {hasPermission('delete_orders') && (
                           <button className="btn-delete" onClick={() => handleDeleteClick(order)} title="Sil">
                               <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                <polyline points="3 6 5 6 21 6"/>
                                <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                                <path d="M10 11v6M14 11v6"/>
                                <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                              </svg>
                          </button>
                            )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
              <tr style={{background:'#f0f4ff', fontWeight:'700', borderTop:'3px solid #667eea'}}>
                <td colSpan={selectMode ? 7 : 6} style={{padding:'12px', textAlign:'right', color:'#555', fontSize:'13px'}}>
                  TOPLAM ({totalCount} sipariş)
                </td>
                <td style={{padding:'12px', color:'#2e7d32', fontSize:'14px'}}>
                  {formatCurrency(grandTotals.total_revenue)}
                </td>
                <td style={{padding:'12px', color:'#1565c0', fontSize:'14px'}}>
                  {formatCurrency(grandTotals.total_paid)}
                </td>
                <td style={{padding:'12px', color:'#c62828', fontSize:'14px'}}>
                  {formatCurrency(grandTotals.total_remaining)}
                </td>
                <td colSpan={3}></td>
              </tr>
            </tfoot>
            </table>
          </div>
        )}
      </div>
     {totalCount > 0 && (
      <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'8px', padding:'20px', flexWrap:'wrap'}}>
        
        <select 
          value={pageSize} 
          onChange={(e) => { 
            const newSize = Number(e.target.value);
            setPageSize(newSize); 
            localStorage.setItem('userPageSize', newSize);
            fetchData(1, newSize); 
          }} 
          style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', marginRight:'8px', cursor:'pointer', fontSize:'14px', background:'white'}}
        > 
          <option value={50}>50 kayıt</option> 
          <option value={100}>100 kayıt</option> 
          <option value={250}>250 kayıt</option>
        </select>

        <button onClick={() => { window.scrollTo(0,0); fetchData(1); }} disabled={currentPage===1}
          style={{padding:'8px 12px', borderRadius:'6px', border:'1px solid #ddd', cursor:currentPage===1?'not-allowed':'pointer', background:currentPage===1?'#f5f5f5':'white'}}>«</button>
        <button onClick={() => { window.scrollTo(0,0); fetchData(currentPage-1); }} disabled={currentPage===1}
          style={{padding:'8px 12px', borderRadius:'6px', border:'1px solid #ddd', cursor:currentPage===1?'not-allowed':'pointer', background:currentPage===1?'#f5f5f5':'white'}}>‹</button>

        {totalPages > 1 && Array.from({length: totalPages}, (_, i) => i+1)
          .filter(p => p===1 || p===totalPages || Math.abs(p-currentPage)<=2)
          .reduce((acc, p, i, arr) => {
            if (i > 0 && p - arr[i-1] > 1) acc.push('...');
            acc.push(p);
            return acc;
          }, [])
          .map((p, i) => p==='...' ? (
            <span key={`dots-${i}`} style={{padding:'8px 4px'}}>...</span>
          ) : (
            <button key={p} onClick={() => { window.scrollTo(0,0); fetchData(p); }}
              style={{padding:'8px 14px', borderRadius:'6px',
                border:`1px solid ${currentPage===p?'#667eea':'#ddd'}`,
                background:currentPage===p?'linear-gradient(135deg,#667eea,#764ba2)':'white',
                color:currentPage===p?'white':'#333',
                cursor:'pointer', fontWeight:currentPage===p?'600':'normal'}}>
              {p}
            </button>
          ))
        }

        <button onClick={() => { window.scrollTo(0,0); fetchData(currentPage+1); }} disabled={currentPage===totalPages}
          style={{padding:'8px 12px', borderRadius:'6px', border:'1px solid #ddd', cursor:currentPage===totalPages?'not-allowed':'pointer', background:currentPage===totalPages?'#f5f5f5':'white'}}>›</button>
        <button onClick={() => { window.scrollTo(0,0); fetchData(totalPages); }} disabled={currentPage===totalPages}
          style={{padding:'8px 12px', borderRadius:'6px', border:'1px solid #ddd', cursor:currentPage===totalPages?'not-allowed':'pointer', background:currentPage===totalPages?'#f5f5f5':'white'}}>»</button>

        <span style={{color:'#666', fontSize:'14px', marginLeft:'8px'}}>
          {((currentPage - 1) * pageSize) + 1}-{Math.min(currentPage * pageSize, totalCount)} / {totalCount} sipariş | Sayfa {currentPage} / {totalPages}
        </span>
      </div>
    )}
      {/* Sipariş Ekleme/Düzenleme Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={editingOrder ? 'Sipariş Düzenle' : 'Yeni Sipariş'}
        size="large"
      >
        <form onSubmit={handleSubmit}>
          <div className="form-section">
            <h3 style={{marginBottom: '15px', fontSize: '16px', color: '#333'}}>Müşteri Bilgileri</h3>
            
            <div className="customer-search-container">
              <div className="form-group">
                <label>Müşteri Ara veya Yeni Gir</label>
                <div className="customer-search-wrapper">
                  <input
                    type="text"
                    value={customerSearchTerm}
                    onChange={(e) => handleCustomerSearch(e.target.value)}
                    placeholder="Müşteri adı veya telefon ile ara..."
                    className="customer-search-input"
                    autoComplete="off"
                  />
                  {customerSearchTerm && (
                    <button type="button" onClick={handleClearCustomer} className="customer-clear-btn">✕</button>
                  )}
                </div>
                
                {showCustomerDropdown && (
                  <div className="customer-dropdown">
                    {filteredCustomers.length > 0 ? (
                      filteredCustomers.map(customer => (
                        <div 
                          key={customer.id} 
                          className="customer-dropdown-item"
                          onClick={() => handleSelectCustomer(customer)}
                        >
                          <div className="customer-dropdown-name">{customer.name}</div>
                          {customer.phone && (
                            <div className="customer-dropdown-phone">{customer.phone}</div>
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="customer-dropdown-empty">
                        <p>Müşteri bulunamadı</p>
                        <button type="button" onClick={handleManualEntry} className="btn-new-customer">
                          "{customerSearchTerm}" olarak yeni müşteri ekle
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
              
              {formData.customer_id && (
                <div className="selected-customer-badge">
                  <span>✓</span> Mevcut müşteri: {formData.customer_name}
                </div>
              )}
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Müşteri Adı *</label>
                <input
                  type="text"
                  value={formData.customer_name}
                  onChange={(e) => setFormData({...formData, customer_name: e.target.value})}
                  required
                  placeholder="Müşteri adı"
                />
              </div>
              <div className="form-group">
                <label>Telefon {formData.customer_id && <small style={{color: '#888', fontWeight: 'normal'}}>(Müşteri kaydını da günceller)</small>}</label>
                <input
                  type="text"
                  value={formData.customer_phone}
                  onChange={(e) => setFormData({...formData, customer_phone: formatPhoneNumber(e.target.value)})}
                  placeholder="0(5XX) XXX XX XX"
                />
              </div>
            </div>
          </div>

          <div className="form-section" style={{marginTop: '20px'}}>
            <h3 style={{marginBottom: '15px', fontSize: '16px', color: '#333'}}>Sipariş Bilgileri</h3>
            
            <div className="form-row">
              <div className="form-group">
                <label>İş Tipi</label>
                <input
                  type="text"
                  value={formData.job_type}
                  onChange={(e) => setFormData({...formData, job_type: e.target.value})}
                  placeholder=""
                />
              </div>
              <div className="form-group">
                <label>Durum</label>
                <select
                  value={formData.status}
                  onChange={(e) => setFormData({...formData, status: e.target.value})}
                >
                  <option value="siparis_alindi">Sipariş Alındı</option>
                  <option value="uretimde">Üretimde</option>
                  <option value="teslim_edildi">Teslim Edildi</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label>Açıklama</label>
              <textarea
                value={formData.description}
                onChange={(e) => setFormData({...formData, description: e.target.value})}
                rows="3"
                placeholder=""
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Sipariş Tarihi</label>
                <input
                  type="date"
                  value={formData.order_date}
                  onChange={(e) => setFormData({...formData, order_date: e.target.value})}
                />
              </div>
              <div className="form-group">
                <label>Teslim Tarihi</label>
                <input
                  type="date"
                  value={formData.delivery_date}
                  onChange={(e) => setFormData({...formData, delivery_date: e.target.value})}
                />
              </div>
            </div>
          </div>

          <div className="form-section" style={{marginTop: '20px'}}>
            <h3 style={{marginBottom: '15px', fontSize: '16px', color: '#333'}}>Ödeme Bilgileri</h3>
            
            <div className="form-row">
              <div className="form-group">
                <label>Toplam Tutar (₺) *</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.total_price}
                  onChange={(e) => setFormData({...formData, total_price: e.target.value})}
                  required
                  placeholder="0.00"
                />
              </div>
              <div className="form-group">
                <label>Alınan Kapora (₺)</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.down_payment}
                  onChange={(e) => setFormData({...formData, down_payment: e.target.value})}
                  placeholder="0.00"
                />
              </div>
              <div className="form-group">
                <label>Kapora Ödeme Yöntemi</label>
                <select
                  value={formData.down_payment_method}
                  onChange={(e) => setFormData({...formData, down_payment_method: e.target.value})}
                  disabled={!formData.down_payment || parseFloat(formData.down_payment) <= 0}
                >
                  <option value="nakit">Nakit</option>
                  <option value="kredi_karti">Kredi Kartı</option>
                  <option value="havale">Havale/EFT</option>
                  <option value="cek">Çek</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Kalan Borç (₺)</label>
                <input
                  type="text"
                  value={((parseFloat(formData.total_price) || 0) - (parseFloat(formData.down_payment) || 0)).toFixed(2)}
                  disabled
                  style={{backgroundColor: '#f0f0f0', cursor: 'not-allowed'}}
                />
              </div>
              <div className="form-group">
              <label>Siparişi Alan Kişi</label>
              {!showRepInput ? (
              <div style={{display:'flex', gap:'8px'}}>
                <select
                  value={formData.representative}
                  onChange={(e) => setFormData({...formData, representative: e.target.value})}
                  style={{flex:1, padding:'12px 12px', border:'1px solid #ddd', borderRadius:'6px', fontSize:'14px'}}
                >
                  <option value="">Seçiniz...</option>
                  {representatives.map(rep => (
                    <option key={rep.id} value={rep.name}>{rep.name}</option>
                  ))}
                </select>
                {formData.representative && (
                  <button
                    type="button"
                    onClick={() => {
                        setConfirmModal({
                          isOpen: true,
                          title: 'Kişiyi Listeden Kaldır',
                          message: `"${formData.representative}" kişisini listeden kaldırmak istediğinizden emin misiniz?`,
                          type: 'danger',
                          confirmText: 'Evet, Kaldır',
                          loading: false,
                          onConfirm: async () => {
                            try {
                              const rep = representatives.find(r => r.name === formData.representative);
                              if (rep) await deleteRepresentative(rep.id);
                              setRepresentatives(prev => prev.filter(r => r.name !== formData.representative));
                              setFormData({...formData, representative: ''});
                              setConfirmModal(prev => ({ ...prev, isOpen: false }));
                            } catch(e) {
                              toast.error('Silinemedi');
                              setConfirmModal(prev => ({ ...prev, isOpen: false }));
                            }
                          }
                        });
                      }}
                    title="Listeden kaldır"
                    style={{height: '40px', display: 'flex', alignItems: 'center', padding:'1px 10px', background:'#ff5252', color:'white', border:'none', borderRadius:'6px', cursor:'pointer',}}
                  >
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <polyline points="3 6 5 6 21 6"/>
                  <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                  <path d="M10 11v6M14 11v6"/>
                  <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                  </svg>
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => setShowRepInput(true)}
                  style={{height: '40px', display: 'flex', alignItems: 'center', padding:'1px 12px', background:'linear-gradient(135deg,#667eea,#764ba2)', color:'white', border:'none', borderRadius:'6px', cursor:'pointer', whiteSpace:'nowrap', fontSize:'13px'}}
                >
                  + Yeni
                </button>
              </div>
            ) : (
                <div style={{display:'flex', gap:'8px'}}>
                  <input
                    type="text"
                    value={newRepresentative}
                    onChange={(e) => setNewRepresentative(e.target.value)}
                    placeholder="Yeni kişi adı..."
                    style={{flex:1, padding:'8px 12px', border:'1px solid #667eea', borderRadius:'6px', fontSize:'14px'}}
                    autoFocus
                  />
                  <button
                    type="button"
                    onClick={async () => {
                      if (newRepresentative.trim()) {
                        try {
                          const res = await createRepresentative(newRepresentative.trim());
                          setRepresentatives(prev => [...prev, res.data].sort((a,b) => a.name.localeCompare(b.name)));
                          setFormData({...formData, representative: newRepresentative.trim()});
                          setNewRepresentative('');
                        } catch(e) {
                          toast.error('Eklenemedi');
                        }
                      }
                      setShowRepInput(false);
                    }}
                    style={{padding:'8px 12px', background:'linear-gradient(135deg,#4caf50,#2e7d32)', color:'white', border:'none', borderRadius:'6px', cursor:'pointer'}}
                  >
                    ✓
                  </button>
                  <button
                    type="button"
                    onClick={() => { setShowRepInput(false); setNewRepresentative(''); }}
                    style={{padding:'8px 12px', background:'#f0f0f0', color:'#333', border:'none', borderRadius:'6px', cursor:'pointer'}}
                  >
                    ✕
                  </button>
                </div>
              )}
            </div>
            </div>

            <div className="form-group">
              <label style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                <input
                  type="checkbox"
                  checked={formData.invoice_included}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    if (isChecked && formData.total_price) {
                      const basePrice = parseFloat(formData.total_price) || 0;
                      const kdvAmount = basePrice * (formData.kdv_rate / 100);
                      setFormData({
                        ...formData, 
                        invoice_included: true,
                        base_price: basePrice,
                        total_price: (basePrice + kdvAmount).toFixed(2)
                      });
                    } else if (!isChecked && formData.base_price) {
                      setFormData({
                        ...formData, 
                        invoice_included: false,
                        total_price: formData.base_price
                      });
                    } else {
                      setFormData({...formData, invoice_included: isChecked});
                    }
                  }}
                  style={{width: '20px', height: '20px'}}
                />
                Fatura Dahil
              </label>
            </div>

            {/* KDV Oranı Seçimi */}
            {formData.invoice_included && (
              <div className="form-group" style={{marginTop: '10px', padding: '15px', backgroundColor: '#e3f2fd', borderRadius: '8px', border: '1px solid #90caf9'}}>
                <label style={{display: 'block', marginBottom: '10px', fontWeight: '600', color: '#1565c0'}}>
                  📋 KDV Oranı Seçin
                </label>
                <div style={{display: 'flex', gap: '15px', flexWrap: 'wrap'}}>
                  {[20, 10, 7].map(rate => (
                    <label key={rate} style={{
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '8px',
                      padding: '10px 20px',
                      backgroundColor: formData.kdv_rate === rate ? '#1976d2' : 'white',
                      color: formData.kdv_rate === rate ? 'white' : '#333',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      border: formData.kdv_rate === rate ? '2px solid #1976d2' : '2px solid #ddd',
                      fontWeight: '500',
                      transition: 'all 0.2s'
                    }}>
                      <input
                        type="radio"
                        name="kdv_rate"
                        value={rate}
                        checked={formData.kdv_rate === rate}
                        onChange={(e) => {
                          const newRate = parseInt(e.target.value);
                          const basePrice = parseFloat(formData.base_price) || parseFloat(formData.total_price) || 0;
                          const kdvAmount = basePrice * (newRate / 100);
                          setFormData({
                            ...formData,
                            kdv_rate: newRate,
                            base_price: basePrice,
                            total_price: (basePrice + kdvAmount).toFixed(2)
                          });
                        }}
                        style={{display: 'none'}}
                      />
                      %{rate} KDV
                    </label>
                  ))}
                </div>
                
                {/* KDV Hesaplama Özeti */}
                {formData.base_price && (
                  <div style={{marginTop: '15px', padding: '10px', backgroundColor: 'white', borderRadius: '6px', fontSize: '14px'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '5px'}}>
                      <span>Tutar (KDV Hariç):</span>
                      <strong>{parseFloat(formData.base_price).toFixed(2)} ₺</strong>
                    </div>
                    <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '5px', color: '#1976d2'}}>
                      <span>KDV (%{formData.kdv_rate}):</span>
                      <strong>{(parseFloat(formData.base_price) * formData.kdv_rate / 100).toFixed(2)} ₺</strong>
                    </div>
                    <div style={{display: 'flex', justifyContent: 'space-between', paddingTop: '8px', borderTop: '1px solid #eee', fontWeight: '600'}}>
                      <span>Toplam (KDV Dahil):</span>
                      <strong style={{color: '#2e7d32'}}>{formData.total_price} ₺</strong>
                    </div>
                  </div>
                )}
                {/* Fatura No */}
                 <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #bbdefb'}}>
                   <label style={{fontWeight: '500', color: '#1565c0', whiteSpace: 'nowrap', width: '65px'}}>Fatura No:</label>
                     <input
                    type="text"
                    value={formData.invoice_no}
                    onChange={(e) => setFormData({...formData, invoice_no: e.target.value})}
                    placeholder="Fatura numarası"
                    style={{width: '150px', padding: '6px 10px', border: '1px solid #90caf9', borderRadius: '6px', fontSize: '13px', backgroundColor: 'white'}}
                      />
                </div>
              </div>
            )}
          </div>
          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
              İptal
            </button>
            <button type="submit" className="btn btn-primary">
              {editingOrder ? 'Güncelle' : 'Oluştur'}
            </button>
          </div>
        </form>
      </Modal>

      {/* Sipariş Detay Modal */}
      <Modal
        isOpen={isDetailModalOpen}
        onClose={handleCloseDetailModal}
        title={`Sipariş Detayı #${selectedOrder?.id}`}
        size="large"
      >
        {selectedOrder && (
          <div className="order-detail">
            <div className="detail-section">
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <h3>Genel Bilgiler</h3>
                <button 
                  onClick={handlePrintDeliveryNote}
                  style={{
                    padding: '8px 16px',
                    background: 'linear-gradient(135deg, #4caf50, #2e7d32)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  📋 Teslimat Fişi
                </button>
              </div>
              <div className="detail-grid" style={{marginTop: '15px'}}>
                <div className="detail-item">
                  <strong>Müşteri:</strong> {selectedOrder.customer_name}
                </div>
                <div className="detail-item">
                  <strong>Telefon:</strong> {selectedOrder.customer_phone || '-'}
                </div>
                <div className="detail-item">
                  <strong>İş Tipi:</strong> {selectedOrder.job_type || '-'}
                </div>
                <div className="detail-item">
                  <strong>Durum:</strong> 
                  <span className={`status-badge status-${selectedOrder.status}`}>
                    {getStatusLabel(selectedOrder.status)}
                  </span>
                </div>
                <div className="detail-item">
                  <strong>Ödeme Durumu:</strong> 
                  <span className={`badge ${getPaymentStatusClass(getPaymentStatus(selectedOrder))}`}>
                    {getPaymentStatusLabel(getPaymentStatus(selectedOrder))}
                  </span>
                </div>
                <div className="detail-item">
                  <strong>Sipariş Tarihi:</strong> {formatDate(selectedOrder.order_date)}
                </div>
                <div className="detail-item">
                  <strong>Teslim Tarihi:</strong> {formatDate(selectedOrder.delivery_date)}
                </div>
                <div className="detail-item">
                  <strong>Siparişi Alan:</strong> {selectedOrder.representative || '-'}
                </div>
                <div className="detail-item">
                  <strong>Fatura Dahil:</strong> 
                  <span className={`badge ${selectedOrder.invoice_included ? 'badge-success' : 'badge-secondary'}`}>
                    {selectedOrder.invoice_included ? 'Evet' : 'Hayır'}
                  </span>
                </div>
                <div className="detail-item">
                  <strong>Fatura No:</strong> {selectedOrder.invoice_no || '-'}
                </div>
              </div>
              {selectedOrder.description && (
                <div className="detail-item" style={{marginTop: '15px'}}>
                  <strong>Açıklama:</strong>
                  <p>{selectedOrder.description}</p>
                </div>
              )}
            </div>

            <div className="detail-section">
              <h3>Finansal Bilgiler</h3>
              <div className="financial-grid">
                <div className="financial-card">
                  <span className="financial-label">Toplam Tutar</span>
                  <span className="financial-value">{formatCurrency(selectedOrder.total_price)}</span>
                </div>
                <div className="financial-card success">
                  <span className="financial-label">Ödenen</span>
                  <span className="financial-value">{formatCurrency(selectedOrder.total_paid)}</span>
                </div>
                <div className="financial-card warning">
                  <span className="financial-label">Kalan Borç</span>
                  <span className="financial-value">{formatCurrency(selectedOrder.remaining_balance)}</span>
                </div>
              </div>
            </div>

            <div className="detail-section">
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px'}}>
                <h3>Ödeme Geçmişi ({selectedOrder.payments?.length || 0})</h3>
                <div style={{display: 'flex', gap: '10px'}}>
                  {hasPermission('edit_orders') && (
                   <button className="btn btn-danger" onClick={handleOpenRefundModal} disabled={selectedOrder.total_paid <= 0}>
                    ↩ İade Ekle
                    </button>
                    )}
                    {hasPermission('edit_orders') && (
                    <button className="btn btn-primary" onClick={handleOpenPaymentModal} disabled={selectedOrder.remaining_balance <= 0}>
                     + Ödeme Ekle
                     </button>
                     )}
                </div>
              </div>
              
              {selectedOrder.payments && selectedOrder.payments.length > 0 ? (
                <div className="payments-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Tarih</th>
                        <th>Tutar</th>
                        <th>Yöntem</th>
                        <th>Not</th>
                        <th>Kaydeden</th>
                        <th>İşlem</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedOrder.payments.map(payment => (
                        <tr key={payment.id} className={payment.amount < 0 ? 'refund-row' : ''}>
                          <td>{payment.payment_date}</td>
                          <td className={payment.amount < 0 ? 'refund-cell' : 'amount-cell'}>
                            {payment.amount < 0 ? '' : '+'}{formatCurrency(payment.amount)}</td>
                          <td>{payment.payment_method}</td>
                          <td>{payment.notes || '-'}</td>
                          <td>{payment.created_by || '-'}</td>
                          <td>
                            {hasPermission('edit_orders') && (
                             <button className="btn-delete-small" onClick={() => handleDeletePaymentClick(payment)}>
                                 <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                  <polyline points="3 6 5 6 21 6"/>
                                  <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                                  <path d="M10 11v6M14 11v6"/>
                                  <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                                </svg>
                               </button>
                                )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p style={{color: '#666', textAlign: 'center', padding: '20px'}}>
                  Henüz ödeme kaydı yok
                </p>
              )}
            </div>
          </div>
        )}
      </Modal>

      {/* Ödeme Ekleme Modal */}
      <Modal
        isOpen={isPaymentModalOpen}
        onClose={handleClosePaymentModal}
        title="Ödeme Ekle"
        size="medium"
      >
        <form onSubmit={handleAddPayment}>
          <div className="form-group">
            <label>Tutar (₺) *</label>
            <input
              type="number"
              step="0.01"
              value={paymentData.amount}
              onChange={(e) => setPaymentData({...paymentData, amount: parseFloat(e.target.value) || 0})}
              required
              min="0.01"
              max={selectedOrder?.remaining_balance}
            />
            <small style={{color: '#666'}}>
              Kalan: {formatCurrency(selectedOrder?.remaining_balance)}
            </small>
          </div>

          <div className="form-group">
            <label>Ödeme Tarihi</label>
            <input
              type="date"
              value={paymentData.payment_date}
              onChange={(e) => setPaymentData({...paymentData, payment_date: e.target.value})}
            />
          </div>

          <div className="form-group">
            <label>Ödeme Yöntemi</label>
            <select
              value={paymentData.payment_method}
              onChange={(e) => setPaymentData({...paymentData, payment_method: e.target.value})}
            >
              <option value="nakit">Nakit</option>
              <option value="kredi_karti">Kredi Kartı</option>
              <option value="havale">Havale/EFT</option>
              <option value="cek">Çek</option>
            </select>
          </div>

          <div className="form-group">
            <label>Not</label>
            <input
              type="text"
              value={paymentData.notes}
              onChange={(e) => setPaymentData({...paymentData, notes: e.target.value})}
              placeholder=""
            />
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={handleClosePaymentModal}>
              İptal
            </button>
            <button type="submit" className="btn btn-primary">
              Ödeme Ekle
            </button>
          </div>
        </form>
      </Modal>

      {/* İade Modal */}
      <Modal
        isOpen={isRefundModalOpen}
        onClose={handleCloseRefundModal}
        title="İade Ekle"
        size="medium"
      >
        <form onSubmit={handleAddRefund}>
          <div className="form-group">
            <label>İade Tutarı (₺) *</label>
            <input
              type="number"
              step="0.01"
              value={refundData.amount}
              onChange={(e) => setRefundData({...refundData, amount: parseFloat(e.target.value) || 0})}
              required
              min="0.01"
              max={selectedOrder?.total_paid}
            />
            <small style={{color: '#666'}}>
              Toplam ödenen: {formatCurrency(selectedOrder?.total_paid)}
            </small>
          </div>

          <div className="form-group">
            <label>İade Tarihi</label>
            <input
              type="date"
              value={refundData.payment_date}
              onChange={(e) => setRefundData({...refundData, payment_date: e.target.value})}
            />
          </div>

          <div className="form-group">
            <label>İade Yöntemi</label>
            <select
              value={refundData.payment_method}
              onChange={(e) => setRefundData({...refundData, payment_method: e.target.value})}
            >
              <option value="nakit">Nakit</option>
              <option value="kredi_karti">Kredi Kartı</option>
              <option value="havale">Havale/EFT</option>
            </select>
          </div>

          <div className="form-group">
            <label>İade Nedeni</label>
            <input
              type="text"
              value={refundData.notes}
              onChange={(e) => setRefundData({...refundData, notes: e.target.value})}
              placeholder="İade nedeni..."
            />
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={handleCloseRefundModal}>
              İptal
            </button>
            <button type="submit" className="btn btn-danger">
              İade Ekle
            </button>
          </div>
        </form>
      </Modal>

      {/* Onay Modalı */}
      <ConfirmModal
        isOpen={confirmModal.isOpen}
        onClose={() => setConfirmModal(prev => ({ ...prev, isOpen: false }))}
        onConfirm={confirmModal.onConfirm}
        title={confirmModal.title}
        message={confirmModal.message}
        type={confirmModal.type}
        confirmText={confirmModal.confirmText}
        loading={confirmModal.loading}
      />

      <style>{`
        .date-filter-divider {
          color: #999;
          font-size: 12px;
          padding: 0 8px;
          display: flex;
          align-items: center;
        }
        
        .btn-clear-filter {
          background: #ff5252;
          color: white;
          border: none;
          width: 45px;
          height: 45px;
          border-radius: 50%;
          cursor: pointer;
          font-size: 18px;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 1;
          transition: all 0.2s;
          flex-shrink: 0;
        }
        
        .btn-clear-filter:hover {
          background: #d32f2f;
          transform: scale(1.1);
        }
      `}</style>
    </div>
  );
}

export default Orders;